import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deleteBank } from "../thunks/deleteBank";
import { setFetchState } from "../banksDataReducer";

export const useBankDelete = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.listing.banks.fetchState
  );

  const dispatch = useDispatch();
  const dispatchDeletebank = React.useCallback(
    (id: string) => dispatch(deleteBank(id)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchDeletebank] as [
    typeof fetchState,
    typeof dispatchDeletebank
  ];
};
